import React, { useEffect, useRef, useState } from 'react'

interface videoProps {
    src: string;
    controls?: boolean;
    simpleControls?: boolean;
    className?: string;
    muted?: boolean;
    loop?: boolean;
    autoPlay?: boolean;
    style?: React.CSSProperties;
}

export default function ({
    src = "",
    controls = true,
    simpleControls = false,
    className = "",
    muted = false,
    loop = false,
    autoPlay = false,
    style = {}
}: videoProps) {
    const playerRef = useRef<HTMLDivElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);

    const [hasEnded, setEnded] = useState<boolean>(false);
    const [isPlaying, setPlaying] = useState<boolean>(autoPlay);
    const [currentVolume, setVolume] = useState<number>(muted ? 0 : 1);

    function play(event: any) {
        if (videoRef.current == null) return;
        const video = videoRef.current;
        setPlaying(current => {
            setEnded(false)
            if (!current) {
                video.play()
            } else {
                video.pause()
            }
            return !current
        })
    }

    function mute(event: React.MouseEvent<HTMLImageElement, MouseEvent>) {
        setVolume(current => {
            if (current == 0) return 1;
            return 0
        })
    }

    function fullScreen(event: React.MouseEvent<HTMLImageElement, MouseEvent>) {
        if (playerRef.current == null) return;
        const player = playerRef.current;
        event.preventDefault();
        if (!document.fullscreenElement) {
            player.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    }

    const [timePercentage, setTimePercentage] = useState<number>(0);
    function onTimeUpdate(event: React.SyntheticEvent<HTMLVideoElement, Event>) {
        if (videoRef.current == null) return;
        const video = videoRef.current;

        setTimePercentage((video.currentTime / video.duration) * 100)
        if (video.ended) {
            setEnded(true)
            return setPlaying(false)
        }
    }

    function testMiddle() {
        if (videoRef.current == null) return;
        const video = videoRef.current;

        if (video.readyState != HTMLMediaElement.HAVE_ENOUGH_DATA) return;
        if (isNaN(video.duration) == true) return;

        console.log("video", video.seekable, "readyState:", video.readyState)
        
        // console.log("last", video.currentTime, video.duration)
        const newTime = video.duration * 0.5;
        video.currentTime = newTime

        console.log("now", video.currentTime, video.duration)
    }

    useEffect(() => {
        if (videoRef.current == null) return;
        const video = videoRef.current;
        video.volume = currentVolume
    }, [currentVolume])

    return <div
        className={
            'group non-selectable overlapper items-end overflow-hidden bg-black w-fit ' +
            '*:non-selectable ' +
            className
        }
        ref={playerRef}
        style={style}
    >
        <video
            className='w-full max-w-[100vw] max-h-screen h-[inherit] pointer-events-none'
            ref={videoRef}
            crossOrigin='anonymous'
            preload='auto'
            muted={muted}
            loop={loop}
            playsInline={true}
            autoPlay={autoPlay}
            onTimeUpdate={event => onTimeUpdate(event)}
        >
            <source src={src} type='video/mp4' />
        </video>
        {controls && <div
            className={
                '[--controlHeight:2.5rem] ' +
                'opacity-0 z-0 flex items-center justify-between h-[var(--controlHeight)] transition-opacity duration-300 ' +
                'group-hover:opacity-100 ' +
                '[&_img]:h-12 [&_img]:p-2 [&_img]:cursor-pointer '
            }
        >
            <img
                src={`/images/${hasEnded == false ? (isPlaying ? 'pause' : 'play') : 'repeat'}.png`}
                onClick={event => play(event)} draggable={false}
            />

            {/* <button className='filled-btn' onClick={() => testMiddle()}>test</button> */}
            {
                !simpleControls ? <>
                    <div className='h-[var(--controlHeight)] flex-[1] flex items-end border-none [mask-image:linear-gradient(90deg,_transparent_1%,_white_20%)]'>
                        <div className='h-[75%] flex-[1]'>
                            <div
                                className='bg-primary rounded-tl-2xl rounded-tr-2xl h-full transition-[width] duration-[400ms] ease-linear'
                                style={{ width: `${timePercentage}%` }}
                            />
                        </div>
                    </div>

                </> : <div className='h-[var(--controlHeight)] flex-[1] flex items-end border-none' />
            }
            <div className='overlapper justify-center justify-items-center h-12 group/volume'>
                <img
                    className='peer'
                    src={`/images/sound_${currentVolume <= 0.01 ? 'off' : 'on'}.png`}
                    onClick={event => mute(event)}
                    draggable={false}
                />
                <div 
                    className={
                        'opacity-0 pointer-events-none relative -top-28 w-4 h-28 ' +
                        'peer-hover:opacity-100 peer-hover:[pointer-events:inherit] hover:[pointer-events:inherit] hover:opacity-100 group-hover/volume:opacity-100'
                    }
                >
                    <input
                        className={
                            '[background:linear-gradient(var(--outline),#00000060)_var(--outline)] ' +
                            '[--targetHeight:0%] [writing-mode:vertical-lr] [direction:rtl] appearance-none rounded-[0.4rem] videoRange ' +
                            'cursor-pointer overflow-hidden w-4 h-full'
                        }
                        type="range"
                        onChange={e => setVolume(parseInt(e.target.value) / 100)}
                        style={{ "--targetHeight": `${currentVolume * 100}%` } as React.CSSProperties}
                        value={currentVolume * 100}
                    />
                </div>
            </div>
            <img
                src={`/images/fullscreen.png`}
                onClick={event => fullScreen(event)}
                draggable={false}
            />
        </div>}
    </div>
}
